//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {HeadBar, CellRow} from '@/components';
import OrderStatusBox from './components/OrderStatusBox';
import ExpenseDetail from './components/ExpenseDetail';
import {OrderProxy} from '@/http/RequestProxy.class';
import utils from '@/utils/utils';

const orderProxy = new OrderProxy();

export default {
  name: 'order-detail',
  components: {
    OrderStatusBox,
    HeadBar,
    CellRow,
    ExpenseDetail,
  },
  data(){
    return {
      isShowExpenseDetail: false, // 显示费用明细
      orderId: '',
      orderInfo: {},
      buttonInfo: {},
    };
  },
  computed: {
    lanType(){
      return +window.localStorage.getItem('lan_type');
    },
  },
  mounted(){
    utils.saveLangAndCurrency(this.$route.query);

    this.orderId = this.$route.params.order_id;
    this.getOrderDetail();
  },
  methods: {
    getOrderDetail(){
      this.$vux.loading.show({text: this.$i18n.t('hotel.LOADING')});
      orderProxy.getOrderDetail({lan_type: 1, order_id: this.orderId})
        .then(resp => {
          if(resp){
            this.orderInfo = resp.data;
            this.buttonInfo = resp.data.button_info;
          }
          this.$vux.loading.hide();
        });
    },

    /** 格式化起始日期 */
    formatDate(){
      let today = new Date().getTime();
      let start = Number(this.orderInfo.booking_start_time) * 1000;
      let curStart = '';
      let curEnd = '';

      if(today <= start){
        curStart = utils.formatDateWithStamp(start, true);
        curEnd = utils.formatDateWithStamp(Number(this.orderInfo.booking_end_time) * 1000, true);
      }else{
        const {today, tomorrow} = utils.getTodayAndTomorrow();

        curStart = `${today[0]}-${today[1]}-${today[2]}`;
        curEnd = `${tomorrow[0]}-${tomorrow[1]}-${tomorrow[2]}`;
      }

      return {start_date: curStart, end_date: curEnd};
    },

    /** 支付倒计时结束，重新获取订单详情 */
    onRemainEnded(){
      this.getOrderDetail();
    },

    /** 再次预订 */
    onBookAgain(){
      const params = Object.assign({}, {hotel_id: this.orderInfo.hotel_id}, this.formatDate());

      this.$router.push({
        name: 'hotel-detail',
        params: params,
      });
    },

    /** 取消订单 */
    onCancel(ev, orderId, orderStatus){
      this.$router.push({
        name: 'hotel-order-cancel',
        params: {
          order_id: orderId,
          order_status: orderStatus,
          cancel_rules: this.orderInfo.cancel_policy_info,
        }
      });
    },

    /** 支付订单 */
    onToPay(){
      window.location.href = `${window.location.origin}/m/hotel/payment?order_id=${this.orderId}&currency_code=${localStorage.getItem('currency_code')}`;
    },

    /** 返回订单列表 */
    onBackToList(){
      window.location.href = `${this.$store.state.WAP_HOST}order.php?act=order_list`;
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/order/order-detail.vue